/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Rule_Min_LengthInputs */



/**
* | output |
* | --- |
* | "Password contains at least 12 characters" |
*
* @param {Password_Rule_Min_LengthInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const password_rule_min_length = /** @type {((inputs?: Password_Rule_Min_LengthInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Rule_Min_LengthInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Password contains at least 12 characters")
	return /** @type {LocalizedString} */ ("Le mot de passe contient au moins 12 caractères")
});